import { createMuiTheme } from '@material-ui/core'
import theme from 'design-framework/utils/base-ui-theme'

export const bmsTheme = createMuiTheme({
	palette: {
		primary: {
			main: theme.primary(theme).backgroundColor,
			light: theme.primary(theme).backgroundColor,
			dark: theme.primary(theme).backgroundColor,
		},
		secondary: {
			main: theme.primary(theme).backgroundColor,
		},
	},
	typography: {
		htmlFontSize: '16px',
	},
})

export const __wrapper = () => ({
	marginTop: '28px',
})

export const __errorMessage = () => ({
	color: theme.colors.errorRed,
	fontSize: theme.font.size12,
	margin: 0,
	display: '-webkit-box',
	'-webkit-line-clamp': 1,
	'-webkit-box-orient': 'vertical',
	overflow: 'hidden',
})

export const __description = props => ({
	color: theme.primary(theme).formTextColor,
	fontSize: props.theme.fontSize.s,
	marginTop: '4px',
})
